<div class="one3d-scrollable-wrapper-custom">
  <div class="one3d-acc-wrapper" *ngFor="let kit of kits">
    <div class="one3d-acc">
      <div class="one3d-acc-card">
        <div class="one3d-acc-img-section">
          <img
            class="one3d-acc-img"
            [src]="kit.pack_thumb_url"
            alt="Accessory image"
          />
        </div>
        <div class="one3d-acc-content">
          <p
            class="one3d-acc-content-title"
            style="font-weight: 800 !important"
          >
            {{ kit?.packageName }}
          </p>
          <p class="one3d-acc-content-price one3d-acc-content-discount-price">
            <b>
              {{ globalService.currencyFormatter(kit?.pack_price) }}
              <i *ngIf="kit.actual_price">
                {{ globalService.currencyFormatter(kit?.actual_price) }}</i
              ></b
            >
            <span *ngIf="kit.actual_price"
              >({{
                calculateOffPercentage(kit?.pack_price, kit?.actual_price)
              }}% off)</span
            >
          </p>
          <div class="one3d-acc-content-bottom">
            <button
              class="one3d-acc-view-details-btn"
              (click)="viewDetails(kit)"
            >
              <!-- {{ kit.viewDetails ? "View Less" : "View Details" }} -->
              {{ kit.viewDetails ? ('KITS.VIEW_LESS' | translate) : ('KITS.VIEW_DETAILS' | translate) }}


            </button>
            <button
              class="one3d-acc-add-btn"
              [hidden]="kit.is_default === 'yes'"
              *ngIf="!accessoriesService.packAdded(kit)"
              (click)="
                addPack(
                  kit,
                  accessoriesService.ifAccessoryAlreadyAdded(kit),
                  accessoriesService.ifPackOverlaps(kit)
                )
              "
              translate
            >
            KITS.ADD
            </button>
            <button
              class="one3d-acc-remove-btn"
              [hidden]="kit.is_default === 'yes'"
              *ngIf="accessoriesService.packAdded(kit)"
              (click)="accessoriesService.removePack(kit)"

              translate
            >
            KITS.REMOVE
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="kit?.viewDetails" class="one3d-sub-acc-wrapper">
      <div class="one3d-sub-acc-top">
        <p class="one3d-sub-acc-title">{{ kit?.packageName }} {{'KITS.INCLUDES' | translate}}</p>
      </div>
      <div
        class="one3d-sub-acc"
        *ngFor="let accessories of kit?.accessoriesList"
      >
        <div class="one3d-sub-acc-img-section">
          <img
            class="one3d-sub-acc-img"
            [src]="accessories.thumb_url"
            alt="Accessory image"
          />
        </div>
        <div class="one3d-sub-acc-content">
          <p class="one3d-sub-acc-content-title">
            {{ accessories.marketing_name }}
          </p>
          <div
            *ngIf="!accessories.viewAccessory"
            class="one3d-sub-acc-content-bottom"
          >
            <button
              class="one3d-acc-view-btn"
              *ngIf="accessoriesService.packAdded(kit) || kit.is_default === 'yes'"
              (click)="viewAccessoryFromPack(accessories)"

              translate
            >
            KITS.VIEW
            </button>
          </div>
          <div
            *ngIf="accessories.viewAccessory"
            class="one3d-sub-acc-content-bottom"
          >
            <button
              class="one3d-acc-view-btn"
              *ngIf="accessoriesService.packAdded(kit)"
              (click)="exitView(accessories)"

              translate
            >
            KITS.EXIT
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
